import { render, staticRenderFns } from "./TallasView.vue?vue&type=template&id=77d59d8a&"
import script from "./TallasView.vue?vue&type=script&lang=js&"
export * from "./TallasView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports